//created from:
//SELECT REPLACE(REPLACE(REPLACE([Name],' ',''),'-','_'), '&', '') + ' = ' + CONVERT(varchar, SourceSystemId) + ',' from [dbo].[SourceSystems] aa WITH(NOLOCK) ORDER BY SourceSystemId

export enum SourceSystem {
  PetPass = 1,
  vetPoint = 2,
  SALK = 3,
  VOB = 4,
  Idexx = 5,
  RXService = 6,
  VetSpire = 7,
  MA_Austin = 8,
}
